import { createFeature, createReducer, on } from '@ngrx/store';
import { currentLanguageUpdated } from '../actions/translate.actions';

export interface TranslateStoreState {
  currentLanguage: string;
}

const initialState: TranslateStoreState = {
  currentLanguage: 'en',
};

export const translateFeature = createFeature({
  name: 'translate',
  reducer: createReducer(
    initialState,
    on(currentLanguageUpdated, (state, action) => {
      return {
        ...state,
        currentLanguage: action.language,
      };
    }),
  ),
});

export const { name, reducer, selectTranslateState, selectCurrentLanguage } =
  translateFeature;
